import * as Contants from './constants';

export default function FeedReducer(state=[], action) {

    switch(action.type) {
        case Contants.START_LOAD_FEEDS: return {state: action.type, data: action.data || {}};
        case Contants.FINISH_LOAD_FEEDS: return {state: action.type, data: action.data || {}};
        case Contants.ERROR_LOAD_FEEDS: return {state: action.type, data: action.data || {}};

        case Contants.START_ADD_READ_FEED: return {state: action.type, data: action.data || {}};
        case Contants.FINISH_ADD_READ_FEED: return {state: action.type, data: action.data || {}};
        case Contants.ERROR_ADD_READ_FEED: return {state: action.type, data: action.data || {}};

        case Contants.START_ADD_BOOKMARK_FEED: return {state: action.type, data: action.data || {}};
        case Contants.FINISH_ADD_BOOKMARK_FEED: return {state: action.type, data: action.data || {}};
        case Contants.ERROR_ADD_BOOKMARK_FEED: return {state: action.type, data: action.data || {}};

        case Contants.START_LOAD_BOOKMARKS: return {state: action.type, data: action.data || {}};
        case Contants.FINISH_LOAD_BOOKMARKS: return {state: action.type, data: action.data || {}};
        case Contants.ERROR_LOAD_BOOKMARKS: return {state: action.type, data: action.data || {}};

        case Contants.START_REMOVE_BOOKMARK: return {state: action.type, data: action.data || {}};
        case Contants.FINISH_REMOVE_BOOKMARK: return {state: action.type, data: action.data || {}};
        case Contants.ERROR_REMOVE_BOOKMARK: return {state: action.type, data: action.data || {}};

        case Contants.START_LOAD_FEED: return {state: action.type, data: action.data || {}};
        case Contants.FINISH_LOAD_FEED: return {state: action.type, data: action.data || {}};
        case Contants.ERROR_LOAD_FEED: return {state: action.type, data: action.data || {}};

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/models/feeds/reducer.js